<template>
    <d2-container type="card" :filename="filename">
        <d2-crud
                :columns="columns"
                :data="data"
                :loading="loading"
                title="用户管理"
                :pagination="pagination"
                :rowHandle="rowHandle"
                :form-template="formTemplate"
                :form-options="formOptions"
                @row-remove="handleRowRemove">
            <el-button slot="headerButton" @click="addData">
                <d2-icon name="plus"></d2-icon>
            </el-button>
            <el-button slot="headerButton" @click="getData">
                <d2-icon name="refresh"></d2-icon>
            </el-button>
        </d2-crud>
    </d2-container>
</template>

<script>
    import UserImg from "@/pages/components/userImg.vue"
    import UserEditor from "@/pages/components/userEditor.vue"

    export default {
        name: "index",
        components: {UserImg, UserEditor},
        data() {
            return {
                filename: __filename,
                columns: [
                    {
                        title: '头像',
                        key: 'imgurl',
                        component: {
                            // name: "div",
                            render: function (h, row) {
                                console.log(row.imgurl.substring(0, 4))
                                return h("img", {
                                    attrs: {
                                        src: row.imgurl.substring(0, 4) === 'http' ? row.imgurl : "//cdn.heanny.cn/HeadPortrait/" + row.imgurl,
                                        height: '50px',
                                        width: '50px',
                                    }
                                })
                            }
                        }
                    }, {
                        title: '账户',
                        key: 'username'
                    },
                    {
                        title: '姓名',
                        key: 'name'
                    },
                    {
                        title: '性别',
                        key: 'sex'
                    }, {
                        title: '权限',
                        key: 'role',
                        formatter(row, h, index) {
                            if (row.role === '1' || row.role === 1) {
                                return '管理员'
                            } else if (row.role === '0' || row.role === 0) {
                                return '用户'
                            } else if (row.role === '-1' || row.role === -1) {
                                return '黑名单'
                            } else {
                                return '其他'
                            }
                        }
                    },
                    {
                        title: '电话',
                        key: 'tel'
                    },
                    {
                        title: '邮箱',
                        key: 'mail'
                    },
                    {
                        title: '注册时间',
                        key: 'reg_ip'
                    },
                    {
                        title: '注册IP',
                        key: 'reg_date'
                    },
                    {
                        title: '编辑',
                        key: 'editor',
                        component: {
                            render: function (h, row) {
                                return h(UserEditor, {
                                    attrs: {
                                        row: row
                                    }
                                })
                            }
                        },
                    }
                ],
                data: [],
                loading: false,
                pagination: {
                    pageSize: 10,
                    layout: 'prev, pager, next, total'
                },
                rowHandle: {
                    columnHeader: '删除',
                    remove: {
                        text: '',
                        icon: 'el-icon-delete',
                        size: 'small',
                        fixed: 'right',
                        confirm: true,
                    },
                    custom: []
                },
                formTemplate: {
                    imgurl: {
                        title: '头像',
                        value: '',
                        component: {
                            render: function (h, row) {
                                return h(UserImg, {
                                    attrs: {
                                        class: "avatar-uploader",
                                    },
                                    props: {
                                        url: "test.php",
                                        imageUrl: row ? '//cdn.heanny.cn/HeadPortrait/' + row : '',
                                        data: {action: 'addUserImg'}
                                    }
                                })
                            }
                        }
                    }, username: {
                        title: '账户',
                        value: ''
                    },
                    name: {
                        title: '姓名',
                        value: ''
                    },
                    sex: {
                        title: '性别',
                        value: '',
                        component: {
                            name: 'el-select',
                            options: [
                                {
                                    value: '男'
                                }, {
                                    value: '女'
                                },
                            ]
                        }
                    },
                    role: {
                        title: '权限',
                        value: '',
                        component: {
                            name: 'el-select',
                            options: [
                                {
                                    value: '0',
                                    label: '用户'
                                }, {
                                    value: '1',
                                    label: '管理员'
                                },
                            ]
                        }
                    }, tel: {
                        title: '电话',
                        value: ''
                    }, position: {
                        title: '职业',
                        value: ''
                    }, text: {
                        title: '介绍',
                        value: ''
                    }

                },
                formOptions: {
                    labelWidth: '80px',
                    labelPosition: 'left',
                    saveLoading: false
                }
            }
        },
        methods: {
            handleRowRemove({index, row}, done) {
                this.$request({
                    url: 'delUser.do', data: {
                        username: row.username
                    }
                }).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    done()
                }).catch((error) => {
                    this.msg = error
                })
            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({url: "getUsers.do",}).then(res => {
                    _this.data = res
                    this.loading = false

                }).catch((error) => {
                    this.msg = error
                    this.loading = false
                })
            },
            addData() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'user-add',
                })
                location.href = '/#/user/add/'
            }
        },
        created: function () {
            this.getData()
        }
    }
</script>

<style scoped>

</style>
